import { visitableType } from '~/assets/js/utils/visitable-type'

const concatPathname = (base, path) => {
  const regexOptionalLeadingSlash = /^\/?/

  return base + path.replace(regexOptionalLeadingSlash, '')
}

// Atributos do `page_view` que alimentam o push `gambit.manual_do_enem.tracking`
// no dataLayer (antes feito em plugins/gambit.js). Tudo que é calculado fica
// aqui; o mapping do Montilla só copia `from -> to`.
export function buildGambitPageAttributes (route, base = '/') {
  const { query, path } = route

  const manualVisitablePath = concatPathname(base, path)

  return {
    gclid: query.gclid ?? '',
    noBaseUserIdRequired: true,
    noVisitableIdRequired: true,
    user_agent: (typeof navigator !== 'undefined' && navigator?.userAgent) || '',
    utm_campaign: query.utm_campaign ?? '',
    utm_content: query.utm_content ?? '',
    utm_medium: query.utm_medium ?? '',
    utm_source: query.utm_source ?? '',
    utm_term: query.utm_term ?? '',
    visitable_path_manual: manualVisitablePath,
    visitableType: visitableType(path),
    zanpid: query.zanpid ?? '',
  }
}
